import {KeyIcon} from '../../../icons'
import {SimpleBlueButton} from '../../core/button'

const RecoveryCodesSection = ({text, disabled, onRegenerate}) => {
    return (
        <div className='security-card'>
            <div className='security-card-content'>
                <div className='security-icon security-icon--neutral'>
                    <KeyIcon opacity={1} fill="currentColor"/>
                </div>
                <div className='security-info'>
                    <h3 className='security-card-title'>{text.recovery_codes_title}</h3>
                    <p className='security-card-description'>
                        {disabled ? text.recovery_codes_disabled_info : text.generate_new_codes_description}
                    </p>
                </div>
                <SimpleBlueButton
                    outline
                    onClick={onRegenerate}
                    disabled={disabled}
                >
                    {text.generate_new_codes}
                </SimpleBlueButton>
            </div>
        </div>
    )
}

export default RecoveryCodesSection
